import React from 'react';
import AdminSettings from '../AdminSettings';

/**
 * Demo settings admin page. Wraps the existing AdminSettings (demo mode,
 * customer-facing demo properties, parcel aliasing) on its own URL
 * (`/admin/demo`). The wrapped component is unchanged.
 */
export default function DemoAdmin() {
  return <AdminSettings embedded />;
}
